import logoo from "../src/assets/logo.jpg"
export const base_url_for_socket = "https://melbourne.27aicouncil.com";
export const uuid = "f241e362-92c9-4600-a526-5aaaa23e4b55";
export const senderId = "AI5699";
export const DISPLAY_PHONE_NUMBER = "61433768627";
export const BOT_UUID = "f241e362-92c9-4600-a526-5aaaa23e4b55";
export const phone_number_id = "684802998056809";
const LOGO_B64 = process.env.REACT_APP_BRAND_LOGO_BASE64 || '';
export const logo = LOGO_B64 || logoo;
// API Base URL (from env): set REACT_APP_BACKEND_API_BASE to https://backend.<domain>
function computeBackendBaseFromWindow() {
  try {
    const { protocol, hostname } = window.location;
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      const domain = parts.slice(1).join('.'); // drop first label
      return `${protocol}//backend.${domain}`;
    }
  } catch {}
  return '';
}

const envBase = (process.env.REACT_APP_BACKEND_API_BASE || '').replace(/\/$/, '');
const fallbackBase = computeBackendBaseFromWindow();
const base = envBase || fallbackBase;
export const API_BASE = base ? `${base}/api` : "";
